export default "__VITE_ASSET__ddab3fbf__"